import ReactRangePicker from './RangePicker';
export default ReactRangePicker;
